var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0.856906 0.184935C0.701271 0.0704475 0.494952 0.052834 0.322423 0.140902C0.150405 0.228969 0.0418701 0.407694 0.0418701 0.602997V23.3969C0.0418701 23.5923 0.150405 23.771 0.322423 23.859C0.395121 23.8963 0.474986 23.915 0.553827 23.915C0.660826 23.915 0.767313 23.8813 0.856906 23.815L16.2156 12.418C16.3472 12.3201 16.4245 12.1647 16.4245 12C16.4245 11.8352 16.3472 11.6798 16.2156 11.5819L0.856906 0.184935Z","fill":"white"}));
}

Play.defaultProps = {"width":"17","height":"24","viewBox":"0 0 17 24","fill":"none"};

module.exports = Play;

Play.default = Play;
